<template>
    <div>
        <h1>Support</h1>

         <div v-html="tag"></div>

    </div>
</template>

<script>
let tag = '<script type="application/javascript"'
tag += ' src="https://jsd-widget.atlassian.com/assets/embed.js"'
tag += ' data-key="2282be93-4eb9-4cec-8041-3f59828532a1"'
tag += ' data-base-url="https://jsd-widget.atlassian.com">'
tag += '<' + '/script>'

// function jiraHelpdesk (callback) {
//   var jhdScript = document.createElement('script')
//   jhdScript.type = 'text/javascript'
//   jhdScript.setAttribute('data-jsd-embedded', null)
//   jhdScript.setAttribute('data-key', '2282be93-4eb9-4cec-8041-3f59828532a1')
//   jhdScript.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com')
//   jhdScript.src = 'https://jsd-widget.atlassian.com/assets/embed.js'
//   // if (jhdScript.readyState) { // old IE support
//   //   jhdScript.onreadystatechange = function () {
//   //     if (jhdScript.readyState === 'loaded' || jhdScript.readyState === 'complete') {
//   //       jhdScript.onreadystatechange = null
//   //       callback()
//   //     }
//   //   }
//   // } else { // modern browsers
//   jhdScript.onload = function () {
//     callback()
//   }
//   // }
//   document.getElementsByTagName('head')[0].appendChild(jhdScript)
// }

export default {
  data () {
    return {
      atlassianTag: '<p color="red">Pink banana</p>',
      tag: tag
    }
  },
  created () {
    // const script = document.createElement('script')
    // script.setAttribute('type', 'application/javascript')
    // script.setAttribute('src', 'https://jsd-widget.atlassian.com/assets/embed.js')
    // script.setAttribute('data-key', '2282be93-4eb9-4cec-8041-3f59828532a1')
    // script.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com')
    // // script.setAttribute('data-jsd-embedded', null)
    // // script.async = true
    // document.head.appendChild(script)
    // console.log(script)
    var jhdScript = document.createElement('script')
    jhdScript.type = 'text/javascript'
    jhdScript.setAttribute('data-jsd-embedded', null)
    jhdScript.setAttribute('data-key', '2282be93-4eb9-4cec-8041-3f59828532a1')
    jhdScript.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com')
    jhdScript.src = 'https://jsd-widget.atlassian.com/assets/embed.js'
    document.getElementsByTagName('head')[0].appendChild(jhdScript)
    // eslint-disable-next-line camelcase
    var DOMContentLoaded_event = document.createEvent('Event')
    DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true)
    window.document.dispatchEvent(DOMContentLoaded_event)
  }
}
</script>
